import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { useRecoilState } from 'recoil';
import { actionsArticlesListPaginationState } from '../../../api/articles/actions';

export type PostPaginationProps = StandardDivProps<PostPaginationClassKey>;

export type PostPaginationClassKey = 'root';

const themeSettings = { name: 'PostPagination' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<PostPaginationClassKey, {}>({
      root: {
        padding: theme.spacing(3.5, 0),
        display: 'flex',
        justifyContent: 'center',
      },
    }),
  themeSettings,
);

const PostPagination = React.forwardRef<HTMLDivElement, PostPaginationProps>(
  ({ className, classes: pClasses }, ref) => {
    const classes = useStyles({ classes: pClasses });
    const [pagination, setPagination] = useRecoilState(actionsArticlesListPaginationState);

    const page = pagination.page || 1;
    const totalPages = pagination?.totalPages;

    const handleChangePage = React.useCallback(
      (event: any, nextPage: number) => {
        setPagination({ page: nextPage });
        window.scrollTo(0, 0); // Přidáno pro posunutí na vrchol stránky
      },
      [setPagination],
    );

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        <Pagination
          count={totalPages}
          color='primary'
          page={page}
          renderItem={(item) => <PaginationItem {...item} />}
          onChange={handleChangePage}
        />
      </div>
    );
  },
);

PostPagination.displayName = 'PostPagination';

export default withThemeProps(themeSettings)(PostPagination);
